import { xyArrayAlign } from 'ml-spectra-processing';
/**
 * Generate a jsgraph chart format from an array of Analysis
 * @param analyses
 * @param options
 */
export function toMatrix(analyses, options = {}) {
    const { selector = {}, normalization, xLabel = 'x', delta = 0, endOfLine = '\n', } = options;
    const data = [];
    const labels = [xLabel];
    const titles = ['x'];
    for (const analysis of analyses) {
        const spectra = analysis.getNormalizedSpectra({
            selector,
            normalization,
        });
        for (const spectrum of spectra) {
            titles.push(spectrum.title || '');
            labels.push(analysis.label || '');
            data.push({ x: spectrum.variables.x.data, y: spectrum.variables.y.data });
        }
    }
    const aligned = xyArrayAlign(data, { delta });
    const lines = [labels.join('\t'), titles.join('\t')];
    for (let row = 0; row < aligned.x.length; row++) {
        const line = [aligned.x[row]];
        for (const column of aligned.ys) {
            line.push(column[row]);
        }
        lines.push(line.join('\t'));
    }
    const text = lines.join(endOfLine);
    return text;
}
// need to find all the unique Xs
//# sourceMappingURL=toMatrix.js.map